import React from 'react';

import moment from "moment/moment";
import MinStockInlineEditField from "./MinStockInlineEditField";
import CurrentReplenishmentStock from "../../components/CurrentReplenishmentStock";

export const AreaControlledItem = (props) => {

    const toggleAreaControl = (checked) => {
        props.toggleAreaControl(props.id, checked);
    };

    const renderStockStatus = () => {
        if (props.stockStatus === 'unsynchronized') {
            return <span className="fa fa-circle text-danger"></span>;
        }

        if (props.stockStatus === 'in_stock') {
            return <span className="fa fa-circle text-success"></span>;
        }

        if (props.stockStatus === 'out_of_stock') {
            return <span className="fa fa-circle text-warning"></span>;
        }

        return props.stockStatus;
    };

    const renderReplenishmentStatus = () => {
        if (props.replenishmentStatus === 'active') {
            return <span className="fa fa-play-circle text-success"></span>;
        }

        if (props.replenishmentStatus === 'halted') {
            return <span className="fa fa-pause-circle text-secondary"></span>;
        }

        if (props.replenishmentStatus === 'stopped') {
            return <span className="fa fa-ban text-danger"></span>;
        }

        return props.replenishmentStatus;
    };

    const renderStockInStore = () => {
        if (props.stockStatus === 'unsynchronized') return '--';

        const sameTimeYesterday = moment().subtract(24, 'hours');
        const timeOfLastStockUpdate = moment.utc(props.currentStock.lastUpdatedAt);

        if(timeOfLastStockUpdate.isSameOrAfter(sameTimeYesterday)) {
            return <span title={renderLastStockUpdate()} style={{fontWeight: 'bold', fontSize: 'large'}}>{props.currentStock.stockQuantity}</span>;
        } else {
            return <span title={renderLastStockUpdate()} style={{fontWeight: 'bold', color: 'red', fontSize: 'large'}}>{props.currentStock.stockQuantity}</span>
        }
    };

    const renderReplenishmentStock = () => {
        if (!props.replenishmentStockQuantity) {
            return '--'
        } else {
            return <CurrentReplenishmentStock
                    unlimitedStock={props.unlimitedStock}
                    actualStock={props.replenishmentStockQuantity}
                    reservedStock={props.pendingStockQuantity}
                    availableStock={props.availableStockQuantity}
            />
        }
    };

    const renderLastStockUpdate = () => {
        if (props.stockStatus === 'unsynchronized') return '--';

        const sameTimeYesterday = moment().subtract(24, 'hours');
        const timeOfLastStockUpdate = moment.utc(props.currentStock.lastUpdatedAt);

        const lastUpdatedAt = moment.utc(props.currentStock.lastUpdatedAt).local().format('DD.MM.YYYY HH:mm');
        return lastUpdatedAt;
    };

    const renderHaltButton = () => {
        let disabled = props.replenishmentStatus === 'stopped';

        if (props.active) {
            return (
                <button disabled={disabled} type="button" className="btn btn-danger" title="Nachversorgung stoppen"
                        onClick={() => toggleAreaControl(0)}>
                    <i className="fa fa-pause"></i>
                </button>
            );
        } else {
            return (
                <button disabled={disabled} type="button" className="btn btn-success" title="Nachversorgung aktivieren"
                        onClick={() => toggleAreaControl(1)}>
                    <i className="fa fa-play"></i>
                </button>
            );
        }
    };

    const renderForceReplenishmentButton = () => {
        let disabled = props.replenishmentStatus !== 'active';
        const id = props.id;

        return (
            <button disabled={disabled} type="button" className="btn btn-primary" title="Nachversorgung erzwingen"
                    onClick={() => props.forceReplenishment(id)}>
                <i className="fa fa-truck"></i>
            </button>
        );
    };

    const handleMinStockUpdate = (minStockQuantity) => {
        props.updateMinimumStockQuantity(props.id, minStockQuantity)
    };

    const renderRefill = () => {
        if (props.approvedForRefill) {
            return (<i className="fa fa-check-circle text-success" title={"freigegeben"}></i>);
        } else {
            return (<i className="fa fa-times-circle text-danger" title={"nicht freigegeben"}></i>);
        }
    };

    return (
        <tr>
            <td style={{verticalAlign: 'middle'}}>
                <input name="selectItem" type="checkbox" checked={props.isSelected}
                       onChange={() => props.selectItem(props.id)}/>
            </td>
            <td style={{textAlign: 'right', verticalAlign: 'middle'}}>
                {renderStockInStore()}
            </td>
            <td style={{verticalAlign: 'middle', padding: '0',  fontSize: 'large'}}>
                {renderStockStatus()}
            </td>
            <td style={{textAlign: 'right', verticalAlign: 'middle'}}>
                <MinStockInlineEditField width={'100px'} value={props.minimumStockQuantity} onCommit={handleMinStockUpdate}/>
            </td>
            <td style={{textAlign: 'right', verticalAlign: 'middle'}}>
                {renderReplenishmentStock()}
            </td>
            <td style={{verticalAlign: 'middle', padding: '0',  fontSize: 'large'}}>
                {renderReplenishmentStatus()}
            </td>
            <td style={{verticalAlign: 'middle', fontSize: 'large'}}>
                {renderRefill()}
            </td>
            <td>{props.retailerGln}<br/>{props.storeGln}</td>
            <td>{props.retailerName}</td>
            <td>{props.zipCode}<br/>{props.city}</td>
            <td>{props.module.name}</td>
            <td>{props.erpIdno}<br/>{props.gtin}<br/>{props.articleDetails}</td>
            <td>{props.brand}<br/>{props.vendorArticleNumber}</td>
            <td style={{fontSize: 'large'}}>
                {renderHaltButton()}
                {renderForceReplenishmentButton()}
            </td>
        </tr>
    )
};

export default AreaControlledItem;



// WEBPACK FOOTER //
// ./src/admin/areacontrol/overview/AreaControlledItem.js